// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_gR","advertCardHeader__actions":"c-a_gS","advertCardHeader__bottomLabel":"c-a_gT"};